/**
 * Shared design tokens for the landing page.
 *
 * Kept local to this folder (rather than editing the global MUI theme in
 * `_metronic/layout/_core/MaterialThemeProvider.js`) so the redesign can't
 * accidentally affect the authenticated dashboard's styling. The primary
 * accent colour intentionally matches that theme's `palette.primary.main`
 * (#17c191) so the marketing site and the product feel like one brand.
 */
export const colors = {
  primary: "#17c191",
  primaryDark: "#0FA377",
  primarySoft: "#E6F8F2",
  ink: "#12151A",
  inkMuted: "#5B6370",
  inkFaint: "#8A93A0",
  surface: "#FFFFFF",
  surfaceMuted: "#F7F8FA",
  border: "#E7E9EC",
  danger: "#F0506E",
  warning: "#E8A23D"
};

export const fontFamily = "'Inter', 'Roboto', sans-serif";

export const maxWidth = 1160;
